import React from 'react';
import { Layout } from '../components/sections/Layout';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemStrip } from '../components/sections/ProblemStrip';
import { PlatformOverview } from '../components/sections/PlatformOverview';
import { FinalCTA } from '../components/sections/FinalCTA';
export function HomePage() {
  return <Layout data-id="element-785">
      <HeroSection data-id="element-786" />
      <ProblemStrip data-id="element-787" />
      <PlatformOverview data-id="element-788" />
      <FinalCTA data-id="element-789" />
    </Layout>;
}